<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" icon>
        <v-icon>mdi-account</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item @click="onLogout">
        <v-list-item-title>Logga ut</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'AppUserMenu',

  methods: {
    onLogout() {
      this.$sso.logout()
    }
  }
}
</script>
